import React, { forwardRef } from "react";
import { oneOf, string } from "prop-types";

import componentSizes from "../constants/componentSizes";
import { colors, orientations } from "./constants";
import * as S from "./styled";

const Loader = forwardRef(
  (
    { className, color, labelText, orientation, size, ...passThroughProps },
    ref
  ) => (
    <S.Loader
      ref={ref}
      className={className}
      orientation={orientation}
      {...passThroughProps}
    >
      <S.Svg size={size}>
        <S.Circle color={color} />
      </S.Svg>

      {labelText && (
        <S.Body color={color} orientation={orientation}>
          {labelText}
        </S.Body>
      )}
    </S.Loader>
  )
);

Loader.displayName = "Loader";

Loader.propTypes = {
  className: string,
  color: oneOf(Object.values(colors)),
  labelText: string,
  orientation: oneOf(Object.values(orientations)),
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

Loader.defaultProps = {
  className: "",
  color: colors.BRAND,
  labelText: null,
  orientation: orientations.VERTICAL,
  size: componentSizes.MD
};

export default Loader;
